import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { Agent } from "../agent-builder-services/agent.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { SubAgents } from "../agent-builder-model/agent-config";
import { FormServices } from "src/app/services/form.services";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzTableComponent } from "ng-zorro-antd/table";
import { WebhookField } from "src/app/webhook-creator/webhook-creator/webhook-interfaces/configuration";
import { SearchProperties } from "src/app/system-utils/search-input-new/search-input-new.component";
import { Variable } from "src/app/forms/formula-tester/formula-tester.component";

@Component({
  selector: 'agent-builder-subagents',
  templateUrl: './agent-builder-subagents.component.html',
  styleUrls: ['./agent-builder-subagents.component.scss'],
  standalone: false
})
export class AgentBuilderSubagentsComponent implements OnInit {
    editingIndexAgents: any;
    showModalAgents: any;
    @ViewChild('tableSubAgents') tableSubAgents: NzTableComponent<any> = null;
    @Input() variables:Variable[] = [];

    saveAgents() {
        if (this.formSubAgent.invalid) {
            let errors = this.formServices.getFormErrors(this.formSubAgent,[],"\n", 'agentBuilder');
            this.message.error(errors);
            return;
        }

        if ( this.editingIndexAgents === -1){
            this.subagents = [...this.subagents, this.formSubAgent.value];
        }else{
            this.subagents[this.editingIndexAgents] = this.formSubAgent.value;
        }
        this.form.get('allowedAgents')?.setValue(this.subagents);
        console.log(this.form)
        this.tableSubAgents.data = [...this.subagents];    

        this.closeAgentsModal();

    }
    
    closeAgentsModal() {
        this.showModalAgents = false;
        this.editingIndexAgents = -1;
    }

    @Input() agent:Agent;
    @Input() form:FormControl;
    subagents:any[] = [];
    pageIndex:number = 1;
    loading:boolean = false;
    formSubAgent:FormGroup;

    constructor(public fb: FormBuilder, private formServices: FormServices, private message: NzMessageService){}
    
    deleteSubAgent(index:number){
        this.subagents.splice(index,1);
        this.form.get('allowedAgents')?.setValue(this.subagents);
        this.tableSubAgents.data = [...this.subagents];    
    }

    ngOnInit(): void {
        
        this.searchAgentField = {
            placeholder:'agentBuilder.agent',
            disabled:false,
            showKey:true,
            entityName:'Mktpagents',
            fields:{
                keyField:"_id",
                valueField:"agentName"
            },
            condition:"{\"codecontract.key\": {@CODECONTRACT}, \"_id\":{\"$ne\": \"ObjectId('"+this.agent._id+"')\"}}",
            type:"mongo"

        }

        this.formSubAgent = this.fb.group({
            agentId:[null],
            rules: ['', Validators.required],
            maxIterators: [0]
        });

        this.subagents =  (this.form.get('allowedAgents')?.value ?? []) as any[];
    }
    

    openModalAgents(){
        this.editingIndexAgents = -1;
        this.initAgentForm();
        this.showModalAgents = true;
    }
    initAgentForm() {
        this.formSubAgent = this.fb.group({
            agentId:[null],
            rules: ['', Validators.required],
            maxIterators: [0]
        });
    }

    searchAgentField:SearchProperties = null;

    onChangeAgentId(event){
        
    }

    editSubAgent(index:number){
        this.editingIndexAgents = index;
        let agent = this.subagents[index];
        this.formSubAgent.patchValue(agent);
        this.showModalAgents = true;
    }
}